import React from 'react'
import { DeploymentUnitOutlined, ScheduleOutlined } from '@ant-design/icons'
import {
  CalendarDaysIcon,
  DocumentPlusIcon,
  ClipboardDocumentListIcon,
  GlobeAltIcon,
  ScaleIcon,
  ClockIcon,
  EyeSlashIcon,
  DocumentCurrencyDollarIcon,
  CalendarIcon,
  DocumentTextIcon,
  BuildingOffice2Icon,
} from '@heroicons/react/24/solid'
import { IAddonsData } from '@vacationtracker/shared/types/automations'
import { AddonsStatusEnum, IAddon } from '@vacationtracker/shared/types/addons'
import { getAddonsEvents } from '@vacationtracker/shared/common/addons-events'
import type { IGetPurchasedAddonsData } from '../../../types/custom-queries'

export const purchasedStatuses = (data: IGetPurchasedAddonsData['getPurchasedAddons']): Record<string, string> => {
  const addons = [...(data?.addons || []), ...(data?.automations || []), ...(data?.integrations || [])] as IAddon[]
  return Object.fromEntries(addons.map((addon) => [addon.type, addon.status]))
}

export const isSubscribed = (status?: string): boolean => Boolean(status) && status !== AddonsStatusEnum.CANCELED

export const getExtendedAddons = (formatMessage: Function, companyFeatureFlags: string[]) => {
  const events = getAddonsEvents(formatMessage)

  const eventsAddonsExtend = {
    BLACKOUT_PERIOD: {
      icon: <CalendarDaysIcon />,
    },
    SENIORITY_ENTITLEMENT: {
      icon: <DocumentPlusIcon />,
    },
    ENTITLEMENT_BY_ROLE: {
      icon: <ClipboardDocumentListIcon />,
    },
    VISIBILITY: {
      icon: <EyeSlashIcon />,
    },
    PROBATION_PERIOD: {
      icon: <GlobeAltIcon />,
    },
    OPEN_API: {
      icon: <CalendarDaysIcon />,
      allowViewMode: true,
    },
    BAMBOOHR_INTEGRATION: {
      icon: <DeploymentUnitOutlined />,
    },
    ADP: {
      icon: <DocumentCurrencyDollarIcon />,
      allowViewMode: true,
    },
    ZAPIER: {
      icon: <BuildingOffice2Icon />,
      allowViewMode: true,
    },
    MAXIMUM_USERS_AWAY: {
      icon: <ScaleIcon />,
    },
    LEAVE_DURATION_LIMIT: {
      icon: <ClockIcon />,
    },
    LEAVE_REQUEST_NOTICE_PERIOD: {
      icon: <ScheduleOutlined />,
    },
    HR_FIELDS: {
      icon: <DocumentTextIcon />,
    },
    BIRDAY_AND_ANNIVERSARY_REMINDERS: {
      icon: <CalendarIcon />,
    },
  }

  const extendedEvents = events.map((event: IAddonsData) => {
    return {
      ...event,
      icon: eventsAddonsExtend[event.type].icon,
      allowViewMode: eventsAddonsExtend[event.type].allowViewMode || false,
      url: event.featureFlag && !companyFeatureFlags?.includes(event.featureFlag) ? 'coming-soon' : event.url,
    }
  })

  return extendedEvents
}
